<template>
    <v-flex>
        {{ minutes }}:{{ seconds }}
    </v-flex>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  data() {
    return {
      seconds: '00',
      minutes: '00',
    };
  },
  computed: {
    ...mapState('testing', [
      'timer',
    ]),
  },
  mounted() {
    this.parseTimer();
    this.updateTime();

    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  methods: {
    ...mapActions('testing', [
      'parseTimer',
      'killTimer',
    ]),
    updateTime() {
      if (Object.keys(this.timer).length) {
        if (new Date() > new Date(this.timer.time_end)) {
          this.$router.push({name: 'study'});
          this.killTimer();
        }

        let difference = new Date(new Date(this.timer.time_end) - new Date());
        this.minutes = String('0' + difference.getMinutes()).slice(-2);
        this.seconds = String('0' + difference.getSeconds()).slice(-2);
      }
    },
  },
};
</script>
